import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { paginationQuerySchema } from '../../utils/listQuery.schema';
import { billingHistoryListResponseSchema } from '../models/billingHistory.schema';

export const getHistory =
  (endpoint: 'organizations' | 'organization_groups') =>
  (id: ID, query: PaginationQuery) => {
    return {
      endpoint: `/${endpoint}/${id}/billing_history`,
      method: 'GET',
      responseSchema: billingHistoryListResponseSchema,
      query: { ...query, includeTotal: true },
      querySchema: paginationQuerySchema.and(
        z.object({ includeTotal: z.boolean().optional() })
      ),
    } as const;
  };
